import { $CurrentTraffic, $EnterTraffic } from '@lemon8/web-app-shared/atom';
import { defineProxyAtom } from '@lemon8/web-app-shared/util';
import { ExtractAtomValue } from 'jotai';
import { EPageType } from 'shared/constant';

export interface ISharingEnterTraffic extends ExtractAtomValue<typeof $EnterTraffic> {
  pageType: EPageType;

  // // timestamp - 10bits
  // shareTime: string;
  // sharerUid: string;
  // sharerDid: string;

  sharerToken: string;
  sharePlatform: string;
  itemFrom?: string;
  isSharingTest: boolean;
}

export const $SharingEnterTraffic = defineProxyAtom<ISharingEnterTraffic, ExtractAtomValue<typeof $EnterTraffic>>(
  $EnterTraffic,
);
$SharingEnterTraffic.debugLabel = '$SharingEnterTraffic';

interface ISharingCurrentTraffic extends ExtractAtomValue<typeof $CurrentTraffic> {
  pageType: EPageType;
  canonicalUrl: string;
}

export interface IHashtagCurrentTraffic extends ISharingCurrentTraffic {
  pageType: EPageType.HASHTAG;
  hashtagId: string;
}

export interface IGalleryCurrentTraffic extends ISharingCurrentTraffic {
  pageType: EPageType.Gallery;
  groupId: string;
  mediaId: string;
}

export interface IVideoCurrentTraffic extends ISharingCurrentTraffic {
  pageType: EPageType.VIDEO;
  groupId: string;
  mediaId: string;
}

export interface IFizzCurrentTraffic extends ISharingCurrentTraffic {
  pageType: EPageType.FIZZ;
  groupId: string;
  mediaId: string;
}

export interface IPOICurrentTraffic extends ISharingCurrentTraffic {
  pageType: EPageType.POI;
  poiId: string;
}

export interface IUserCurrentTraffic extends ISharingCurrentTraffic {
  pageType: EPageType.USER;
  userLinkName: string;
  userId: string;
}

export type TSharingCurrentTraffic =
  | IHashtagCurrentTraffic
  | IPOICurrentTraffic
  | IGalleryCurrentTraffic
  | IVideoCurrentTraffic
  | IFizzCurrentTraffic
  | IUserCurrentTraffic;

export const $SharingCurrentTraffic = defineProxyAtom<TSharingCurrentTraffic, ExtractAtomValue<typeof $CurrentTraffic>>(
  $CurrentTraffic,
);
$SharingCurrentTraffic.debugLabel = '$SharingCurrentTraffic';
